import { P } from '@/components/common/Typo'
import IconBag from '@/components/icons/IconBag'
import { selectStoreOrder } from '@/redux/order'
import { getOrderItemQuantity } from '@/utils/product'
import { cn } from 'oddle-shop-monorepo.design-system'
import { ReactNode } from 'react'
import { useSelector } from 'react-redux'

const BadgeComponent = (): ReactNode => {
  const storeOrder = useSelector(selectStoreOrder)

  const itemsCount = storeOrder.data?.orderItems
    ? getOrderItemQuantity(storeOrder.data?.orderItems)
    : 0

  const shortedValue = itemsCount > 99 ? '99+' : itemsCount

  return (
    <div className="relative flex items-center">
      <IconBag className="text-header-link-color !h-[34px] !w-auto" />
      {itemsCount > 0 && (
        <div
          key={itemsCount}
          data-testid="badge"
          className={cn(
            'bg-header-link-color animate-badge absolute -top-[5px] left-[15px] flex h-[26px] min-w-[26px] items-center justify-center rounded-full'
          )}
        >
          <P
            className={cn(
              'text-header-background-color m-0 pl-1.5 pr-1.5 text-center font-bold',
              itemsCount > 9 && 'text-sm'
            )}
          >
            {shortedValue}
          </P>
        </div>
      )}
    </div>
  )
}

export default BadgeComponent
